import { lastItem } from './../logic/array';
import { WithTrackingDates } from './date';
import { titleCase } from "title-case";


export interface AgingReportBalance {
  history: number[];
  paid?: boolean;
  paidDate?: string;
  checkNumber?: string;
}

export interface AgingReportMessageEdit {
  message: string;
  deadline?: string;
  editedAt: string;
  editedBy: string;
}

export interface AgingReportMessageResponse extends WithTrackingDates{
  id: string;
  message: string;
  author: string;
  deadline?: string;
  recipients?: string[];
  editHistory?: AgingReportMessageEdit[];
  archivedAt?: string;
  archivedBy?: string;
}
export type Month = string;
export interface AgingReportMessage extends WithTrackingDates {
  id: string;
  author: string;
  deadline: string;
  message: string;
  responses: AgingReportMessageResponse[];
  months: Month[];
  recipients: string[];
  editHistory?: AgingReportMessageEdit[];
  archivedAt?: string;
  archivedBy?: string;
  /** When the follow-up email was sent, keyed by "<follow-up date>:due" so a new date notifies again */
  deadlineNotifications?: Record<string, string>;
}

// AgingReport partition
export interface AgingReportPK {
  group: string;
  facility: string;
  payer: string;
}

// Individual AgingReport id
export interface AgingReportSK {
  residentName: string;
  billType: string;
  index: number;
}


export interface AgingReport extends WithTrackingDates {
  pk: string;
  sk: string;
  residentName: string;
  billType: string;
  medicaidApplication: string;
  agingStatus: string;
  balances: Record<Month, AgingReportBalance>;
  prior: number;
  net: number;
  messages: AgingReportMessage[];
  index?: number;
  archived?: boolean;
  /** Incremented on every single-report update; used for optimistic locking */
  version?: number;
}



export const getAgingReportMessageDeadline = (message: AgingReportMessage) => {
  if (!message.responses?.length) {
    return message.deadline;
  }

  return lastItem(message.responses)?.deadline;
};

export const prettyPrintPkSk = (pk: AgingReportPK, sk: AgingReportSK) => `${titleCase(pk.facility)}/${pk.payer.toUpperCase()} | ${sk.residentName} - ${sk.billType}`;



